/* eslint-disable react/no-danger */
import { Button, Icon } from '@elipssolution/harfang';
import { mdiAlert, mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { Drawer, Stack, styled, Typography } from '@mui/material';
import { useState } from 'react';
import sanitizeHtml from 'sanitize-html';

import { AlertBannerProps } from '../../types/alert';
import Banner from '../Banner';

const AlertBannerContainer = styled(Banner)(({ theme: { palette } }) => ({
	gap: 0,
	padding: 0,
	flexDirection: 'column',
	backgroundColor: palette.error.main,
	color: palette.getContrastText(palette.error.main),

	'& > svg': {
		minWidth: 24,
	},
}));

const AlertBannerContent = styled('div')(({ theme: { palette, spacing } }) => ({
	padding: spacing(1.5, 2),
	boxSizing: 'border-box',
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 1,
	zIndex: 1307,
	backgroundColor: palette.error.main,
	color: palette.getContrastText(palette.error.main),
}));

const StyledDrawer = styled(Drawer)(({ theme: { palette, spacing } }) => ({
	overflow: 'hidden',
	zIndex: 1305,

	'& .MuiPaper-root': {
		overflow: 'hidden',
		zIndex: 1306,

		height: '100%',
		boxSizing: 'border-box',
		display: 'flex',
		justifyContent: 'space-between',
		gap: spacing(2),
		padding: spacing(2),
		paddingTop: `calc(${spacing(2)} + 48px)`,
	},

	'& > div': {
		backgroundColor: palette.error.main,
		color: palette.getContrastText(palette.error.main),
	},
}));

const MobileAlertBanner = ({ content, sanitizeOptions }: AlertBannerProps) => {
	const [isBannerDrawerOpen, setIsBannerDrawerOpen] = useState(false);

	return (
		<AlertBannerContainer>
			<AlertBannerContent onClick={() => setIsBannerDrawerOpen((prevValue) => !prevValue)}>
				<Stack flexDirection="row" gap={1}>
					<Icon path={mdiAlert} size="medium" />
					<Typography>Annonce</Typography>
				</Stack>

				<Icon path={isBannerDrawerOpen ? mdiChevronUp : mdiChevronDown} />
			</AlertBannerContent>

			<StyledDrawer open={isBannerDrawerOpen} anchor="top" onClose={() => setIsBannerDrawerOpen(false)} disablePortal>
				<div
					dangerouslySetInnerHTML={{
						__html: sanitizeHtml(content, sanitizeOptions),
					}}
				/>

				<Stack justifyContent="center" alignItems="center">
					<Button onClick={() => setIsBannerDrawerOpen(false)}>Fermer</Button>
				</Stack>
			</StyledDrawer>
		</AlertBannerContainer>
	);
};

export default MobileAlertBanner;
